import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';
import { AppConfigService } from '@app/services/app-config.service';
import { BaseURL } from "@app/shared/common/serviceURL";

export interface PublishPlanStartResponse {
  statusQueryGetUri?: string;
  value?: {
    published?: boolean;
    message?: string;
  };
}

export interface PublishPlanStatusResponse {
  runtimeStatus?: string;
  lastUpdatedTime?: string;
  output?: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class PublishPlanService {
private apiUrl = AppConfigService.settings.apiUrl;
private readonly httpClient = inject(HttpClient);
  constructor() { }

  getRegion() {
    return (localStorage.getItem('selectedRegion') || '')
  }

  validatePublishPlan() {
       const planId = localStorage.getItem('currentPlanID') || '';
       const region = this.getRegion();
       const fullUrl = `${this.apiUrl}/publish-plan/validate/${planId}/${region}`;
   
       return this.httpClient.get(fullUrl);
  }

    publishPlan(planPayload: any) {
      const region = this.getRegion();
      const fullUrl = `${this.apiUrl}/publish-plan/publish/${region}`;
      return this.httpClient.post<PublishPlanStartResponse>(fullUrl, planPayload);
    }

    getPublishPlanStatus(statusQueryGetUri: string): Observable<PublishPlanStatusResponse> {
      return this.httpClient.get<PublishPlanStatusResponse>(statusQueryGetUri);
    }

    pollUntilComplete(statusQueryGetUri: string, pollIntervalMs: number = 15000): Observable<PublishPlanStatusResponse> {
      return timer(0, pollIntervalMs).pipe(
        switchMap(() => this.getPublishPlanStatus(statusQueryGetUri)),
        takeWhile(
          (status) => !this.isTerminalStatus(status.runtimeStatus),
          true
        )
      );
    }

    private isTerminalStatus(runtimeStatus?: string): boolean {
      return runtimeStatus === 'Completed' || runtimeStatus === 'Failed' || runtimeStatus === 'Terminated';
    }
  
}
